import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Spinner — indicador de carregamento.
 *
 * @typedef {Object} SpinnerProps
 * @property {'sm'|'md'|'lg'} [size='md'] Tamanho do spinner.
 * @property {string} [className] Classes adicionais.
 * @property {string} [label='Carregando'] Texto acessível (aria-label).
 */

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-7 w-7 border-[3px]',
};

export function Spinner({ size = 'md', className, label = 'Carregando' }) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        sizes[size],
        className
      )}
    />
  );
}
